import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { VToggleComponent } from "../../_forms/v-toggle/v-toggle.component";
import './v-flag-toggle.component.scss';

@Component({
    selector: "v-flag-toggle",
    template: require("./v-flag-toggle.component.html")
})
export class VFlagToggleComponent implements OnInit, OnChanges {

    //bindings
    @Input() flag: any;
    @Input() disabled: boolean;
    @Input() currentFlags: any;
    @Output() currentFlagsChange = new EventEmitter<any>();
    @Output() onChanged = new EventEmitter<boolean>();

    @ViewChild(VToggleComponent) toggleComponent: VToggleComponent;

    // state
    hasFlag: boolean;

    constructor() {}

    ngOnInit(): void {
        this.updateFlagState();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.updateFlagState();
    }

    toggle(): void {
        this.toggleComponent?.toggle();
    }

    onToggled(enabled: boolean): void {
        if (enabled) {
            this.addFlag();
        } else {
            this.removeFlag();
        }

        this.updateFlagState();
        this.currentFlagsChange.emit(this.currentFlags);
        this.onChanged.emit(this.hasFlag);
    }

    // ---

    private updateFlagState(): void {
        this.hasFlag = (this.currentFlags & this.flag) === this.flag;
    }

    private addFlag(): void {
        this.currentFlags = this.currentFlags | this.flag;
    }

    private removeFlag(): void {
        this.currentFlags = this.currentFlags & ~this.flag;
    }
}
